export type UserFlair = "admin" | "supporter" | "super-supporter";

type EligibleSubscriptionStatus =
  | "active"
  | "cancel_at_period_end"
  | "paid_once";
// Includes paid_once so flair resolution honors one-time supporter entitlements (ref: DL-001, DL-005).

export interface ResolveUserFlairArgs {
  isAdmin?: boolean | null;
  subscriptionPlan?: string | null;
  subscriptionStatus?: string | null;
}

function isEligibleSubscriptionStatus(
  subscriptionStatus: ResolveUserFlairArgs["subscriptionStatus"],
): subscriptionStatus is EligibleSubscriptionStatus {
  // Acknowledges the new one-time supporter alias while keeping admin precedence intact (ref: DL-001).
  return (
    subscriptionStatus === "active" ||
    subscriptionStatus === "cancel_at_period_end" ||
    subscriptionStatus === "paid_once"
  );
}

function resolveFlairByPlan(
  subscriptionPlan: ResolveUserFlairArgs["subscriptionPlan"],
): UserFlair | null {
  switch (subscriptionPlan) {
    case "supporter":
      return "supporter";
    case "super-supporter":
      return "super-supporter";
    default:
      return null;
  }
}

export function resolveUserFlair({
  isAdmin,
  subscriptionPlan,
  subscriptionStatus,
}: ResolveUserFlairArgs): UserFlair | null {
  if (isAdmin) {
    return "admin";
  }

  if (!isEligibleSubscriptionStatus(subscriptionStatus)) {
    return null;
  }

  return resolveFlairByPlan(subscriptionPlan);
}
